export default function getDefaultWysiwygConfig() {
    return {
        cloudServices: {
            tokenUrl: `${process.env.REACT_APP_SERVER}/api/file-upload-token`,
            uploadUrl: `${process.env.REACT_APP_SERVER}/api/file-upload`,
        }
    }
}
